interface Window {
    initCookieConsent: Function | undefined;
}

// obtain plugin
var cc = window.initCookieConsent?.();

if (cc) {
    // get current language from the html tag
    var current_lang = document.documentElement.lang || 'cs';
    
    // run plugin with your configuration
    cc.run({
        current_lang: current_lang,
        autoclear_cookies: true,
        page_scripts: true,
        gui_options: {
            consent_modal: {
                swap_buttons: true
            }
        },
    
        // onFirstAction: function (user_preferences, cookie) {
            // callback triggered only once
        // },
    
        // onAccept: function (cookie) {
            // ...
        // },
    
        // onChange: function (cookie, changed_preferences) {
            // ...
        // },
    
        languages: {
            'cs': {
                consent_modal: {
                    title: 'Cookies',
                    description: 'Ano, i my používáme <a href="/cookies" target="_blank" class="cc-link">cookies</a>. Díky nim víme, co vás zajímá, a nezatěžujeme vás zbytečnostmi.',
                    primary_btn: {
                        text: 'Tak jo, povolit cookies',
                        role: 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Nastavení',
                        role: 'settings'
                    }
                },
                settings_modal: {
                    title: 'Pokročilá nastavení',
                    save_settings_btn: 'Uložit nastavení',
                    accept_all_btn: 'Povolit vše',
                    reject_all_btn: 'Povolit nezbytné',
                    close_btn_label: 'Zavřít',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Používání cookies',
                            description: 'Abychom vám mohli nabídnout na našich webových stránkách co nejlepší uživatelské prostředí, je nutné používat cookies. Informace o souborech cookie jsou uloženy ve vašem prohlížeči a provádějí funkce, jako je rozpoznávání vaší osoby při návratu na naše webové stránky a pomáhají našemu týmu porozumět, které části webových stránek považujete za zajímavé a užitečné. Více informací o cookies se dozvíte v <a href="https://policies.google.com/technologies/cookies" class="cc-link" target="_blank">Zásady ochrany osobních údajů</a>.'
                        }, {
                            title: 'Nezbytné cookies',
                            description: 'Tyto soubory cookie jsou potřeba pro správné fungování základních funkcí webu. Nelze je tedy vypnout. Pokud by byly vypnuty, nebyli bychom schopni uložit zvolené předvolby a v prohlížeči by se vám při každé návštěvě zobrazovala cookie lišta znovu. Nemusíte se ale bát, neukládají žádné vaše osobní informace.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            }
                        }, {
                            title: 'Statistické cookies',
                            description: 'Tyto webové stránky mohou používat službu Google Analytics ke shromažďování anonymních informací, jako je počet návštěvníků webu a nejoblíbenější stránky.<br><br>Uchování tohoto souboru cookie nám pomáhá zlepšit náš web a ukazuje nám údaje o statistice návštěvnosti.',
                            toggle: {
                                value: 'analytics',
                                enabled: false,
                                readonly: false
                            },
                        }, {
                            title: 'Marketingové cookies',
                            description: 'Cílem těchto cookies je propojit náš web se sociálními a reklamními sítěmi 3. stran jako je např. Facebook nebo Google Ads. Díky tomuto propojení vám můžeme zobrazovat relevantní reklamu i mimo náš web.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            }
                        }
                    ]
                }
            },
            'en': {
                consent_modal: {
                    title: 'Cookies',
                    description: 'Yes, we also use <a href="/cookies" target="_blank" class="cc-link">cookies</a>. Thanks to them, we know what interests you and don\'t bother you with unnecessary things.',
                    primary_btn: {
                        text: 'OK, allow cookies',
                        role: 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Settings',
                        role: 'settings'
                    }
                },
                settings_modal: {
                    title: 'Advanced settings',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Allow all',
                    reject_all_btn: 'Allow necessary only',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Cookie usage',
                            description: 'In order to offer you the best user experience on our website, it is necessary to use cookies. Cookie information is stored in your browser and performs functions such as recognizing you when you return to our website and helping our team understand which parts of the website you find interesting and useful. More information about cookies can be found in our <a href="https://policies.google.com/technologies/cookies" class="cc-link" target="_blank">Privacy Policy</a>.'
                        }, {
                            title: 'Necessary cookies',
                            description: 'These cookies are needed for the proper functioning of basic website features. They cannot be disabled. If they were disabled, we would not be able to save your selected preferences and the cookie bar would appear in your browser every time you visit. Don\'t worry, they don\'t store any of your personal information.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            }
                        }, {
                            title: 'Statistical cookies',
                            description: 'This website may use Google Analytics to collect anonymous information such as the number of visitors to the website and the most popular pages.<br><br>Keeping this cookie enabled helps us improve our website and shows us traffic statistics.',
                            toggle: {
                                value: 'analytics',
                                enabled: false,
                                readonly: false
                            },
                        }, {
                            title: 'Marketing cookies',
                            description: 'The purpose of these cookies is to connect our website with social and advertising networks of 3rd parties such as Facebook or Google Ads. Thanks to this connection, we can show you relevant ads even outside our website.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            }
                        }
                    ]
                }
            }
        }
    });
}
